import _ from 'lodash';

/*
actual_crop_production: 170.2
actual_evapotranspiration: 3.2
actual_evapotranspiration_applied_water: 0 // ignore
actual_transpiration: 3
air_cooling: -10.246                       // ignore
air_temperature_24: 26.6                   // ignore
applied_water_avg_10d: 0                   // irnore
area_percentage_over_irrigation: 33        
area_percentage_requiring_irrigation: 0
attainable_crop_production: 191.431
critical_soil_moisture_root_zone: 0.066
crop_production_cumulative: 10522
crop_production_percentile5: 28.149
crop_production_percentile95: 194.341
date: "2021-11-04" // ignore
field_efficiency_avg_10d: 0 // ignore
fullness: 97
irrigation_yesno: 1 // ignore
leaf_nitrogen: 2.785
leaf_water_potential: -11.08
max_adviced_water: 0 // ignore
min_adviced_water: 0 // ignore
moisture_content_cane: 75 // ignore
name: "Joseph Appiah" // ignore
net_carbon_supply_in_soil: -12.494 // 
organic_matter: 3.987
penmann_monteith_crop_coefficient_kc_avg_10d: 0.76
penmann_monteith_reference_et0: 4.2
precipitation_avg_10d: 2.768
production_gap: 21.563
quality_per: 7 // ignore
relative_humidity_24: 84.5 // ignore
soil_moisture_holding_capacity: 137.99999999999997 
soil_moisture_percentile5: 0.163
soil_moisture_percentile95: 0.239
soil_moisture_root_zone: 0.179
soil_temperature: 27.154
soil_water_potential_critical: -408
soil_water_potential_fc: -100
soil_water_potential_percentile5: -111.7
soil_water_potential_percentile95: -66.109
soil_water_potential_root_zone: -99.8
stomatal_conductance: 9.82
sugar_content_cane: 9.263
theta_fc_sub: 0.177
theta_sat_sub: 0.395
theta_wp_sub: 0.039
time_until_next_irrigation: 0
uniformity_soil_moisture: 0.101
vegetation_cover: 75.9
water_productivity_avg_10d: 5.51
water_unlimited_crop_production: 170.2

*/

const IrriwatchHelpers = (function () {
  const readings = {
    actual_crop_production: {
      precision: 1,
      units: ' kg/day',
      convert_units: 'ha/day',
    },
    actual_evapotranspiration: {
      precision: 1,
    },
    actual_transpiration: {
      precision: 1,
    },
    area_percentage_over_irrigation: {
      units: '%',
      precision: 1,
    },
    attainable_production_percentile95: {
      precision: 1,
      units: ' kg/day',
      convert_units: 'ha/day',
    },
    critical_soil_moisture_root_zone: {
      units: ' cm³',
      precision: 3,
    },
    crop_production_cumulative: {
      name: 'Accum. Crop Production',
      precision: 1,
      units: ' kg',
      convert_units: 'ha',
    },
    crop_production_percentile95: {
      precision: 1,
      units: ' kg/day',
      convert_units: 'ha/day',
    },
    crop_production_percentile5: {
      precision: 1,
      units: ' kg/day',
      convert_units: 'ha/day',
    },
    fullness: {
      units: '%',
    },
    leaf_nitrogen: {
      units: '%',
      precision: 1,
    },
    leaf_water_potential: {
      units: ' bar',
      precision: 1,
    },
    net_carbon_supply_in_soil: {
      precision: 1,
      units: ' kg/day',
    },
    organic_matter: {
      precision: 3,
      units: '%',
    },
    penmann_monteith_crop_coefficient_kc_avg_10d: {
      precision: 2,
    },
    penmann_monteith_reference_et0: {
      precision: 1,
      units: ' mm/day',
    },
    precipitation_avg_10d: {
      precision: 3,
      units: ' mm/day',
    },
    production_gap: {
      units: ' kg/day',
      precision: 3,
    },
    stomatal_conductance: {
      units: ' mm/s',
      precision: 2,
    },
    theta_fc_sub: {
      units: 'cm³',
      precision: 3,
    },
    theta_sat_sub: {
      units: ' cm³',
      precision: 3,
    },
    theta_wp_sub: {
      units: ' cm³',
      precision: 3,
    },
    vegetation_cover: {
      units: '%',
      precision: 1,
    },
    water_unlimited_crop_production: {
      units: 'kg/day',
      precision: 1,
      convert_units: ' hg/day',
    },
    water_productivity_avg_10d: {
      units: 'kg/day',
      precision: 1,
      convert_units: ' hg/day',
    },
  };

  const toFixed = (value, precision) => {
    const power = Math.pow(10, precision || 0); // eslint-disable-line
    return String(Math.round(value * power) / power);
  };

  const displayReading = (name, value, units = false, convert = true) => {
    let newValue = value;
    if (value === undefined) {
      return 'Error';
    }
    if (_.isNaN(value)) {
      return '-';
    }
    if (_.has(readings, name)) {
      if (convert && _.has(readings[name], 'conversion')) {
        newValue = readings[name].conversion(newValue);
      }
      if (_.has(readings[name], 'precision')) {
        newValue = toFixed(newValue, readings[name].precision);
      }
    }
    if (_.isNaN(newValue) || isNaN(newValue)) { // eslint-disable-line
      return '-';
    }

    if (units === true) {
      return `${newValue}${getUnits(name, '', convert)}`;
    }

    return newValue;
  };

  const unconvertReading = (name, value, convert = true) => {
    if (convert && _.has(readings[name], 'unconvert')) {
      return readings[name].unconvert(value);
    }
    return value;
  };

  const getUnits = (readingName, defaultUnits = '', convert = true) => {
    if (_.has(readings, readingName)) {
      if (convert && _.has(readings[readingName], 'convert_units')) {
        return readings[readingName].convert_units;
      }
      if (_.has(readings[readingName], 'units')) {
        return readings[readingName].units;
      }
    }
    return defaultUnits;
  };

  const roundReading = (name, value) => {
    let newValue = value;
    if (_.has(readings, name)) {
      if (_.has(readings[name], 'precision')) {
        newValue = toFixed(newValue, readings[name].precision);
      }
    }
    return newValue;
  };

  const isReadingType = (readingName) => {
    return _.has(readings, readingName);
  };

  return {
    readings,
    isReadingType,
    displayReading,
    getUnits,
    roundReading,
    unconvertReading,
    toFixed,
  };
})();

export default IrriwatchHelpers; // eslint-disable-line
